import { useState } from 'react';
import { ClassesObjectsWrapper } from './ClassesObjects.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import interviewQna from './../../../resources/content/interviewQna.png';

function ClassesObjects() {
   const [open, setOpen] = useState('');
   const toggle = (id: any) => {
      if (open === id) {
         setOpen('');
      } else {
         setOpen(id);
      }
   };

  return(
      <ClassesObjectsWrapper>	
         <header className="entry-header ">
            <h1 className="entry-title" itemProp="headline">Classes &amp; Objects</h1>			
         </header>
         <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
            <p className="text-align-justify">In Java, everything is associated with classes&nbsp;and objects. In other words,  one of the basic concepts of Object-Oriented Programming is classes and objects that revolve around real-life entities.</p>
            <p className="text-align-justify"><strong>Class :</strong></p>
            <ul className="text-align-justify">
               <li>A class is just a group of objects that contains common properties.</li>
               <li>In other words, it is a logical entity.</li>
               <li>A class in Java can contain fields, methods, constructors, blocks, interfaces, etc.</li>
               <li>Syntax – 
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                  {
                     'class <class_name> {\n'+
                     '  //fields and methods\n'+
                     '}'
                  }
                  </SyntaxHighlighter>
                  
               </li>
               <li>Classes are classified into two categories :
                  <ul>
                     <li><strong>Built-in Classes</strong>
                        <ul>
                           <li>Built-in classes are the one that comes bundled within predefined packages in Java and are provided as a part of JDK.</li>
                           <li>Examples :
                              <ul>
                                 <li>java.lang.String</li>
                                 <li>java.lang.System</li>
                                 <li>java.lang.Exception</li>
                                 <li>java.lang.Object</li>
                              </ul>
                           </li>
                        </ul>
                     </li>
                  </ul>
                  <ul>
                     <li><strong>User-Defined Classes</strong>
                        <ul>
                           <li>A user-defined class is the one that is created by the user.</li>
                        </ul>
                     </li>
                  </ul>
               </li>
            </ul>

            <p  className="text-align-justify"><strong>Object :</strong></p>
            <ul  className="text-align-justify">
               <li>An object is an instance of a class</li>
               <li>In other words, it is a logical as well as a physical entity.</li>
               <li>Object consist of state(data), behavior(functionality) and identity(unique id identified by JVM). </li>
               <li>For instance : 
                  <ul>
                     <li>a book
                        <ul>
                           <li>state – size, color, author </li>
                           <li>behavior – reading</li>
                        </ul>
                     </li>
                     <li>a car
                        <ul>
                           <li>state – color, type, average, manufacturer</li>
                           <li>behavior – driving</li>
                        </ul>
                     </li>
                  </ul>
               </li>
               <li>One can create an object of a class in the following ways :
                  <ul>
                     <li><strong>new keyword</strong></li>
                     <li><strong>newInstance() method</strong></li>
                     <li><strong>clone() method</strong></li>
                  </ul>
               </li>
            </ul>

            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'public class Book {\n'+
               '  public Book(String name) {\n'+
               '    System.out.println(name);\n'+
               '  }\n'+
               '  public static void main(String args[]) {\n'+
               '    //object of class Book created using new Operator\n'+
               '    Book book1 = new Book("R.D. Sharma");\n'+
               '\n'+
               '    //object of class Book created using clone method\n'+
               '    Book book2 = (Book) book1.clone();\n'+
               '\n'+
               '    //object of class Book created using newInstance method\n'+
               '    Book book3 = (Book) Class.forName("Book").newInstance();\n'+
               '  }\n'+
               '}'
            }
            </SyntaxHighlighter>

            <div>
               <figure className="aligncenter size-large">
                  <img decoding="async" src={interviewQna} alt="" className="reduced-img" />
               </figure>
            </div>


            <Accordion open={open} toggle={toggle}>
            <AccordionItem>
               <AccordionHeader targetId="1">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>What is Object Cloning in Java?</span>
               </AccordionHeader>
               <AccordionBody accordionId="1">
                  <p className="text-align-justify">Object cloning is nothing but creating a copy of an object. To achieve that, clone() is used in java. For instance –</p>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'Car obj1 = new Car();\n'+
                        'Car obj2 = (Car) obj1.clone();'
                     }
                  </SyntaxHighlighter>
               </AccordionBody>
            </AccordionItem>
            </Accordion>
         </div>
      </ClassesObjectsWrapper>
   )
};
export default ClassesObjects;
